import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { VERIFICATION_MASTER_REFERENCE_DATA } from '../../constants';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerificationMastreReferenceData = createAsyncThunk(
  'stop/getVerificationMasterReferenceData',
  async (params) => {
    const config = {
      headers: {
        Authorization: params,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(VERIFICATION_MASTER_REFERENCE_DATA, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verificationMasterReferenceSlice = createSlice({
  name: 'stop/verificationMasterReference',
  initialState: null,
  reducers: {
    resetVerificationMasterReference: () => null,
  },
  extraReducers: {
    [getVerificationMastreReferenceData.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetVerificationMasterReference } = verificationMasterReferenceSlice.actions;

export default verificationMasterReferenceSlice.reducer;
